import React from 'react';
import { C, font, serif } from '../shared/constants';
import { useScrollReveal, revealStyle } from '../shared';

const TOP_PHOTOS = [
  { name: 'Talabartería GA', photo: '/cards/talabarteria-ga.jpg', color: C.mango,    left: '8%',  rot: -4, dur: 7   },
  { name: 'Lic. Gloria S.',  photo: '/cards/gloria.jpg',          color: C.coral,    right: '8%', rot: 4,  dur: 7.5 },
];

const BOTTOM_PHOTOS = [
  { name: 'Rústico el Once', photo: '/cards/rustico-el-once.jpg', color: C.turquesa, left: '2%',  rot: 3,  dur: 9   },
  { name: 'Rac Pac',         photo: '/cards/rac-pac.jpg',         color: C.turquesa, centered: true, rot: -2, dur: 8.5 },
  { name: 'Tierra Alta',     photo: '/cards/tierra-alta.jpg',     color: C.mango,    right: '2%', rot: -5, dur: 10  },
];

const ALL_PHOTOS = [...TOP_PHOTOS, ...BOTTOM_PHOTOS];
const grad = `linear-gradient(90deg, ${C.turquesa} 0%, ${C.mango} 55%, ${C.coral} 100%)`;

export default function ComunidadFloat({ isMobile }) {
  const reveal = useScrollReveal();

  const [layout, setLayout] = React.useState(() => {
    if (typeof window === 'undefined') return 'full';
    if (window.innerWidth < 900) return 'mobile';
    if (window.innerWidth < 1100) return 'compact';
    return 'full';
  });
  React.useEffect(() => {
    const fn = () => {
      if (window.innerWidth < 900) setLayout('mobile');
      else if (window.innerWidth < 1100) setLayout('compact');
      else setLayout('full');
    };
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  const isMob = isMobile || layout === 'mobile';
  const topW = layout === 'compact' ? 300 : 380;
  const topH = layout === 'compact' ? 215 : 270;
  const botW = layout === 'compact' ? 240 : 300;
  const botH = layout === 'compact' ? 170 : 215;

  const renderPhoto = (p, i, row) => {
    const w = row === 'top' ? topW : botW;
    const h = row === 'top' ? topH : botH;
    const pos = { top: row === 'top' ? 0 : undefined, bottom: row === 'bottom' ? 0 : undefined };
    if (p.left) pos.left = p.left;
    if (p.right) pos.right = p.right;
    if (p.centered) { pos.left = '50%'; }

    return (
      <div
        key={`${row}-${i}`}
        className={row === 'top' ? 'td-com-top' : (p.centered ? 'td-com-bot td-com-centered' : 'td-com-bot')}
        style={{
          '--r': `${p.rot}deg`, '--dur': `${p.dur}s`, '--delay': `${-(i * 1.3)}s`,
          '--glow': p.color,
          ...(isMob
            ? { position: 'static', width: 'auto', height: 140 }
            : { position: 'absolute', width: w, height: h, zIndex: 1, ...pos }
          ),
          borderRadius: 16, overflow: 'hidden',
          boxShadow: '0 16px 40px rgba(0,0,0,0.45)',
          cursor: 'default',
        }}
      >
        <img
          src={p.photo} alt={p.name}
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
        <span style={{
          position: 'absolute', bottom: 8, left: 10,
          fontSize: 12, color: '#fff', fontWeight: 600,
          textShadow: '0 1px 6px rgba(0,0,0,0.7)',
          fontFamily: font,
        }}>{p.name}</span>
      </div>
    );
  };

  return (
    <section
      id="comunidad"
      ref={reveal.ref}
      style={{
        overflow: 'hidden',
        padding: isMob ? '2.5rem 0' : '48px 0 72px',
        borderTop: `1px solid ${C.border}`,
        ...revealStyle(reveal.inView),
      }}
    >
      <div style={{
        position: 'relative', maxWidth: 1280, width: '100%', margin: '0 auto',
        height: isMob ? 'auto' : 900,
        ...(isMob ? { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, padding: '0 16px' } : {}),
      }}>
        {/* ── Center text (inside protected 760×360 zone) ── */}
        <div style={{
          ...(isMob
            ? { gridColumn: 'span 2', textAlign: 'center', marginBottom: 12 }
            : {
                position: 'absolute', left: '50%', top: '50%',
                transform: 'translate(-50%,-50%)',
                width: 760, textAlign: 'center', zIndex: 5,
              }
          ),
        }}>
          <p style={{
            fontSize: 12, letterSpacing: 3, fontWeight: 700,
            textTransform: 'uppercase', color: C.turquesa, margin: '0 0 10px',
          }}>02 · Negocios reales, creciendo juntos</p>

          <h2 style={{
            fontFamily: serif,
            fontSize: isMob ? 42 : 'clamp(56px, 8vw, 112px)',
            lineHeight: 1, margin: '0 0 12px',
            padding: '0 0.15em', overflow: 'visible',
          }}>
            <em style={{
              background: grad, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              backgroundClip: 'text', fontStyle: 'italic',
            }}>Comunidad</em>
          </h2>

          <p style={{
            fontSize: isMob ? 14 : 17, color: 'rgba(255,255,255,0.55)',
            maxWidth: 520, margin: '0 auto 20px', lineHeight: 1.6,
          }}>
            Proyectos que ya juegan en Thinker & Doer, cada uno con su carta, su mundo y su historia.
          </p>

          <button style={{
            position: 'relative', zIndex: 6,
            background: 'transparent', border: `1px solid ${C.border}`,
            borderRadius: 999, padding: '0 22px', height: 46, fontWeight: 700,
            fontSize: 15, color: '#fff', cursor: 'pointer', fontFamily: font,
          }}>Ver toda la comunidad</button>
        </div>

        {/* ── Top row: 2 photos ── */}
        {TOP_PHOTOS.map((p, i) => renderPhoto(p, i, 'top'))}

        {/* ── Bottom row: 3 photos ── */}
        {BOTTOM_PHOTOS.map((p, i) => renderPhoto(p, i, 'bottom'))}
      </div>

      <style>{`
        /* Top photos float upward (away from center) */
        @keyframes tdComUp {
          0%,100% { transform: rotate(var(--r)) translateY(0); }
          50%     { transform: rotate(calc(var(--r) * -0.4)) translateY(-14px); }
        }
        /* Bottom photos float downward (away from center) */
        @keyframes tdComDown {
          0%,100% { transform: rotate(var(--r)) translateY(0); }
          50%     { transform: rotate(calc(var(--r) * -0.4)) translateY(14px); }
        }
        /* Centered bottom photo needs translateX(-50%) preserved */
        @keyframes tdComDownCenter {
          0%,100% { transform: translateX(-50%) rotate(var(--r)) translateY(0); }
          50%     { transform: translateX(-50%) rotate(calc(var(--r) * -0.4)) translateY(14px); }
        }
        .td-com-centered {
          animation-name: tdComDownCenter !important;
        }
        .td-com-top {
          position: relative;
          animation: tdComUp var(--dur) ease-in-out infinite;
          animation-delay: var(--delay);
          transition: box-shadow 0.4s, transform 0.4s cubic-bezier(.16,1,.3,1);
        }
        .td-com-bot {
          position: relative;
          animation: tdComDown var(--dur) ease-in-out infinite;
          animation-delay: var(--delay);
          transition: box-shadow 0.4s, transform 0.4s cubic-bezier(.16,1,.3,1);
        }
        .td-com-top:hover, .td-com-bot:hover {
          animation-play-state: paused;
          transform: rotate(0deg) scale(1.05) !important;
          box-shadow: 0 24px 60px color-mix(in srgb, var(--glow) 40%, transparent) !important;
          z-index: 4 !important;
        }
        .td-com-centered:hover {
          transform: translateX(-50%) rotate(0deg) scale(1.05) !important;
        }
        @media (max-width:899px) {
          .td-com-top, .td-com-bot { animation: none !important; }
        }
        @media (prefers-reduced-motion:reduce) {
          .td-com-top, .td-com-bot { animation: none !important; }
        }
      `}</style>
    </section>
  );
}
